import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ui-input-with-tooltip',
  templateUrl: './ui-input-with-tooltip.component.html',
  styleUrls: ['./ui-input-with-tooltip.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UiInputWithTooltipComponent implements AfterViewInit {
  @Input() public tooltipText: string;
  @ViewChild('container', { static: false }) container: ElementRef<HTMLDivElement>;
  @ViewChild('t', { static: false }) tooltip: NgbTooltip;

  ngAfterViewInit(): void {
    const input = this.container.nativeElement.querySelector('input');

    input.addEventListener('focus', () => {
      this.tooltip.open();
    }, { passive: true });

    input.addEventListener('blur', () => {
      this.tooltip.close();
    }, { passive: true });
  }
}

